import React from 'react';
import { Edit, SimpleForm, TextInput, required, useTranslate } from 'react-admin';
import { FormPageTitle, FormSection, FormToolbar } from '@/components/shell';

const BACK_TO = '/kyc-config?tab=document-types';

export const DocumentTypeEdit = () => {
  const t = useTranslate();
  return (
    <Edit mutationMode="pessimistic" actions={<FormPageTitle mode="edit" />}>
      <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} showDelete />}>
        <FormSection title={t('resources.document-types.name', { smart_count: 1 })}>
          <TextInput source="name" label={t('resources.document-types.fields.name')} validate={required()} fullWidth />
        </FormSection>
      </SimpleForm>
    </Edit>
  );
};
